<template>
  <div
    class="group"
    :class="{ 'is-print': print }">

    <h2 v-if="!print" class="h2">
      {{ territory.id }}.
      <strong>{{ territory.name }}</strong>
    </h2>

    <h3 class="group__title" v-if="print">Lista adresów, których nie odwiedzać</h3>
    <div :class="{ 'has-border': print }">
      <table class="table" :class="{ 'is-narrow': print }">
        <colgroup>
          <col style="width: 150px" />
        </colgroup>
        <thead>
          <tr>
            <th>Data</th>
            <th>Adres</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="({ date, address, key }, index) in group"
            :key="`nv-${index}`">

            <td>{{ date }}</td>
            <td>{{ address }}</td>
            <td class="has-text-right">
              <button
                v-if="territory"
                class="button is-small"
                type="button"
                @click="remove(key)">
                Usuń
              </button>
            </td>
          </tr>
          <tr
            v-for="(r, index) in diff"
            :key="`empty-row-${index}`">
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="group__note" v-if="print">
      Wpisy w powyższy blankiet dokonuje <u>tylko</u> sługa terenów.
    </p>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  props: {
    group: {
      type: Array,
      default: () => [],
    },
    territoryKey: String,
    print: Boolean,
  },
  data: () => ({
    minRows: 5,
  }),
  computed: {
    ...mapGetters({
      getItem: 'getItem',
    }),
    territory() {
      if (this.territoryKey !== '') {
        return this.getItem(this.territoryKey).item;
      }

      return null;
    },
    diff() {
      const { length } = this.group;

      if (this.print && length < this.minRows) {
        return this.minRows - length;
      }

      return 0;
    },
  },
  methods: {
    ...mapMutations({
      remove: 'REMOVE_NV',
    }),
  },
};
</script>

<style lang="scss" scoped>
.group {
  margin-bottom: 2rem;
}

.h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.table {
  width: 100%;
  max-width: 40rem;
  margin-left: 2rem;
}

.is-print {
  width: 136mm;
  outline: 1px dotted #ddd;
  padding: 4mm 6mm 3mm;
  margin: 0 auto;

  .group__title {
    font-size: .625rem;
    margin-bottom: .35rem;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
    color: #000;
  }

  .group__note {
    color: #666;
    font-style: italic;
    font-size: .625rem;
    margin-top: .35rem;
  }

  .table {
    border: 1px solid #ccc;
    font-size: .6875rem;
    max-width: 100%;
    width: 100%;
    margin: 0;
  }
}
</style>
